import Join from '../../components/join/Join';

const JoinPage = () => {
    return (
        <>
            <Join />
        </>
    );
};

export default JoinPage;
